import { render, staticRenderFns } from "./createCT.vue?vue&type=template&id=135a332b&scoped=true&"
import script from "./createCT.vue?vue&type=script&lang=js&"
export * from "./createCT.vue?vue&type=script&lang=js&"
import style0 from "./createCT.vue?vue&type=style&index=0&id=135a332b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a332b",
  null
  
)

export default component.exports